import { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';

// Module routes
import { competitorsRoutes } from '@/modules/competitors';
import { battlesRoutes } from '@/modules/battles';
import { adminRoutes } from '@/modules/admin';
import { leaderboardRoutes } from '@/modules/leaderboard';
import { battleSetsRoutes } from '@/modules/battle-sets';
import { userProfileRoutes } from '@/modules/user-profile';

// Lazy load shared/global pages
const LoginUser = () => import('@/pages/Login/LoginUser.vue');
const SignupUser = () => import('@/pages/Signup/SignupUser.vue');
const ErrorPage = () => import('@/components/common/ErrorPage.vue');
const InformationPage = () => import('@/pages/Information/InformationPage.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: Urls.LOGIN,
  },
  {
    path: Urls.LOGIN,
    name: 'login',
    component: LoginUser,
    meta: { public: true },
  },
  {
    path: Urls.SIGNUP,
    name: 'signup',
    component: SignupUser,
    meta: { public: true, requiresAuth: false },
  },
  {
    path: Urls.MY_ACCOUNT,
    redirect: Urls.USER_PROFILE_PROFILE,
  },
  // {
  //   path: Urls.USER_PROFILE,
  //   name: 'userProfile',
  //   component: () => import('@/pages/UserProfile/UserProfileLayout.vue'),
  //   meta: { requiresAuth: true },
  //   redirect: Urls.USER_PROFILE_PROFILE,
  //   children: [
  //     {
  //       path: 'profile',
  //       name: 'userProfileProfile',
  //       component: () => import('@/pages/UserProfile/UserProfileProfile.vue'),
  //       meta: { requiresAuth: true },
  //     },
  //     {
  //       path: 'change-password',
  //       name: 'userProfileChangePassword',
  //       component: () => import('@/pages/UserProfile/UserProfileChangePassword.vue'),
  //       meta: { requiresAuth: true },
  //     },
  //     {
  //       path: 'theme',
  //       name: 'userProfileTheme',
  //       component: () => import('@/pages/UserProfile/UserProfileTheme.vue'),
  //       meta: { requiresAuth: true },
  //     },
  //     {
  //       path: 'changelog',
  //       name: 'userProfileChangelog',
  //       component: () => import('@/pages/UserProfile/UserProfileChangelog.vue'),
  //       meta: { requiresAuth: true },
  //     },
  //     {
  //       path: 'notifications',
  //       name: 'userProfileNotifications',
  //       component: () => import('@/pages/UserProfile/UserProfileNotifications.vue'),
  //       meta: { requiresAuth: true, requiresSupervisor: true },
  //     },
  //   ],
  // },

  {
    path: Urls.INFORMATION,
    name: 'information',
    component: InformationPage,
    meta: { requiresAuth: true },
  },
  ...battlesRoutes,
  ...competitorsRoutes,
  ...adminRoutes,
  ...leaderboardRoutes,
  ...battleSetsRoutes,
  ...userProfileRoutes,
  // ── Error pages ─────────────────────────────────────────────
  {
    path: Urls.PAGE_NOT_FOUND,
    name: 'notFound',
    component: ErrorPage,
    props: { code: 404 },
    meta: { public: true },
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: ErrorPage,
    props: { code: 403 },
    meta: { public: true },
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: ErrorPage,
    props: { code: 401 },
    meta: { public: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: Urls.PAGE_NOT_FOUND,
  },
];